import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewFollowerCount } = appStoreLenses

export default viewFollowerCount
